import {OpenTelemetryTransport} from '@loglayer/transport-opentelemetry'
import {maskDeep} from '@src/utility/sentry/misc'
import {type LogLayerMetadata, LogLayer} from 'loglayer'
import {serializeError} from 'serialize-error'

import {initOtel} from './otel'

// businessNumber é o CPF/CNPJ do lead (getEventProperties()) — documento completo que
// não pode ir para os metadados OTel (ME-7448 anti-goal). email fica de fora de propósito:
// é exigido no contexto do usuário (OtelInjector.setUser) para correlacionar leads no Grafana.
const REDACTION_FIELDS = ['password', 'token', 'refreshToken', 'refresh_token', 'businessNumber']

const IS_DEV = import.meta.env.VITE_ENVIRONMENT === 'development'

initOtel()

export const otelLogger = new LogLayer({
  errorFieldName: 'error',
  errorSerializer: serializeError,
  plugins: [
    {
      onMetadataCalled(metadata) {
        if (!metadata) return metadata

        return maskDeep(metadata, REDACTION_FIELDS) as LogLayerMetadata
      }
    }
  ],
  transport: [
    new OpenTelemetryTransport({
      enabled: !IS_DEV,
      onError: error => console.error('[OtelLogger] transport error:', error)
    })
  ]
})
